// This is a Map because order is important in some display contexts, and this
// constant is used to generate the display

// TODO: this is the most fucked mess, refactor it ffs
const TimePeriods: Record<string, any> = new Map([
  ['OneDay',
    {
      value         : 'P1D',
      display_short : '1D',
      display       : '1 Day'
    }
  ],
  [
    'OneWeek',
    {
      value         : 'P7D',
      display_short : '1W',
      display       : '7 Days'
    }
  ],
  [
    'OneMonth',
    {
      value         : 'P30D',
      display_short : '1M',
      display       : '1 Month'
    }
  ],
  [
    'ThreeMonths',
    {
      value         : 'P90D',
      display_short : '3M',
      display       : '3 Months'
    }
  ],
  [
    'SixMonths',
    {
      value         : 'P180D',
      display_short : '6M',
      display       : '6 Months'
    }
  ],
  [
    'OneYear',
    {
      value         : 'P365D',
      display_short : '1Y',
      display       : '1 Year'
    }
  ]]
);

const FlowVariables: Record<string, any> = {
  Discharge   : {
    parameterCd   : '00060',
    units         : 'CFS',
    display       : 'Discharge',
    key           : 'Discharge',
  },
  GaugeHeight : {
    parameterCd   : '00065',
    units         : 'FT',
    display       : 'Gauge Height',
    key           : 'GaugeHeight',
  }
};

const SecondaryVariables: Record<string, any> = {
  WaterTemp   : {
    parameterCd   : '00010',
    units         : '°F',
    display       : 'Water Temperature',
    key           : 'WaterTemp',
  },
  AirTemp     : {
    parameterCd   : '00020',
    units         : '°C',
    display       : 'Air Temperature',
    key           : 'AirTemp',
  },
  Precip      : {
    parameterCd   : '00045',
    units         : '?',
    display       : 'Precipitation',
    key           : 'Precip',
  }
};

// NOTES: Interesting variables

// these three are on http://localhost:8081/sites/ut/09180500/detail
//
// 00095 - specific conductivity (chocolate milk?)
// 80154 - suspended-sediment concentration (USGS parameter code 80154)
// 80155 - suspended sediment discharge

const RouteNames = {
  Search          : "Search",
  MiniDetail      : "MiniDetail",
  Detail          : "DetailModal",
  Main            : "Main",
  NearLocation    : "NearLocation",
};

const StatesAndTerritories: Array<Record<string, string>> = [

  { key: 'AL', label: 'Alabama' },
  { key: 'AK', label: 'Alaska' },
  { key: 'AZ', label: 'Arizona' },
  { key: 'AR', label: 'Arkansas' },
  { key: 'CA', label: 'California' },
  { key: 'CO', label: 'Colorado' },
  { key: 'CT', label: 'Connecticut' },
  { key: 'DC', label: 'D.C.' },
  { key: 'DE', label: 'Delaware' },
  { key: 'FL', label: 'Florida' },
  { key: 'GA', label: 'Georgia' },
  { key: 'GU', label: 'Guam' },
  { key: 'HI', label: 'Hawaii' },
  { key: 'ID', label: 'Idaho' },
  { key: 'IL', label: 'Illinois' },
  { key: 'IN', label: 'Indiana' },
  { key: 'IA', label: 'Iowa' },
  { key: 'KS', label: 'Kansas' },
  { key: 'KY', label: 'Kentucky' },
  { key: 'LA', label: 'Louisiana' },
  { key: 'ME', label: 'Maine' },
  { key: 'MD', label: 'Maryland' },
  { key: 'MA', label: 'Massachusetts' },
  { key: 'MI', label: 'Michigan' },
  { key: 'MN', label: 'Minnesota' },
  { key: 'MS', label: 'Mississippi' },
  { key: 'MO', label: 'Missouri' },
  { key: 'MT', label: 'Montana' },
  { key: 'NE', label: 'Nebraska' },
  { key: 'NV', label: 'Nevada' },
  { key: 'NH', label: 'New Hampshire' },
  { key: 'NJ', label: 'New Jersey' },
  { key: 'NM', label: 'New Mexico' },
  { key: 'NY', label: 'New York' },
  { key: 'NC', label: 'North Carolina' },
  { key: 'ND', label: 'North Dakota' },
  { key: 'OH', label: 'Ohio' },
  { key: 'OK', label: 'Oklahoma' },
  { key: 'OR', label: 'Oregon' },
  { key: 'PA', label: 'Pennsylvania' },
  { key: 'PR', label: 'Puerto Rico' },
  { key: 'RI', label: 'Rhode Island' },
  { key: 'SC', label: 'South Carolina' },
  { key: 'SD', label: 'South Dakota' },
  { key: 'TN', label: 'Tennessee' },
  { key: 'TX', label: 'Texas' },
  { key: 'UT', label: 'Utah' },
  { key: 'VT', label: 'Vermont' },
  { key: 'VA', label: 'Virginia' },
  { key: 'WA', label: 'Washington' },
  { key: 'WV', label: 'West Virginia' },
  { key: 'WI', label: 'Wisconsin' },
  { key: 'WY', label: 'Wyoming' }
];

export default {

  COLORS: {

    // DEPRECATED!
    GREEN   : '#66C8A8',
    BLUE    : '#338FD3',
    ORANGE  : 'orange',

    // IMPORTANT: These colors must match up with scss defs in variables.scss!
    OSF_BLUE: '#1A9BF0',
    OSF_DARK_BLUE: '#003A7E',
    OSF_DOBLE_DARK_GRAY: '#222',
    OSF_DARK_GRAY: '#444',
    OSF_MEDIUM_GRAY: '#666',
    OSF_LIGHT_GRAY: '#888',
    OSF_GREEN: '#70DAE9'
  },

  // IMPORTANT: These .js breakpoint values must match up with scss defs in variables.scss and
  //            other places!
  DesktopMinWidth       : 800,
  ShortMobileMinHeight  : 580,

  StructuralStyles: {
    DesktopTrayWidth            : '440',
    MobileTrayCollapsedHeight   : '90',
    MobileTrayExpandedHeight    : '450'
  },

  TimePeriods,
  FlowVariables,
  SecondaryVariables,
  RouteNames,

  StatesAndTerritories
};
